import { FC } from "react";
import styled from "styled-components";
import { color } from "@styles";
import { mobile, tablet } from "components/templates/Breakpoints";
import { Category } from "pages/resource-hub";
import Link from "next/link";

interface ExploreOtherCategoriesSection {
  path: string;
  categories: Category[];
}

function returnLinkFromPath(path: string, slug: string): string {
  if (path.includes("blog/")) {
    return `/blog/category/${slug}/`;
  }

  return `/resource-hub/category/${slug}/`;
}

export const ExploreOtherCategoriesSection: FC<ExploreOtherCategoriesSection> = ({
  categories,
  path,
}) => {
  return (
    <Margin>
      <Container>
        <SectionTitle>Explore other categories</SectionTitle>
        <CardContainer>
          {categories.map(({ slug, iconSrc, iconAlt, name }) => {
            return (
              <Link href={returnLinkFromPath(path, slug)} key={slug}>
                <Card>
                  <Img src={iconSrc} alt={iconAlt} />
                  <Title>{name.toUpperCase()}</Title>
                </Card>
              </Link>
            );
          })}
        </CardContainer>
      </Container>
    </Margin>
  );
};

const SectionTitle = styled.h2`
  margin: 0 0 5.625rem;

  ${tablet} {
    margin: 3.5rem 0 5rem;
  }

  ${mobile} {
    font-size: 2.5rem;
  }
`;

const CardContainer = styled.div`
  display: grid;
  gap: 2.625rem;
  grid-template-columns: repeat(auto-fill, minmax(21.75rem, 1fr));

  ${tablet} {
    gap: 1.5rem;
  }

  ${mobile} {
    gap: 1rem;
    display: flex;
    flex-direction: column;
  }
`;

const Card = styled.div`
  background: ${color.S3100};
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  transition: 150ms ease-out;

  &:hover {
    transform: translateY(-0.5rem);
  }
`;

const Img = styled.img`
  border-radius: 0.5rem;
`;

const Title = styled.p`
  color: ${color.white};
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.063rem;
  max-width: 11.25rem;
  margin-left: 1.5rem;
`;

const Margin = styled.div`
  width: 100%;
  padding: 7.5rem 10.5%;
  background: ${color.S310};

  ${tablet} {
    padding: 3.5rem 6%;
  }

  ${mobile} {
    padding: 2.5rem 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 70.5rem;
  margin: 0 auto;
`;
